import { useCallback, useContext, useEffect, useState } from "react";
import { DeviceDetailContext } from "@pages/Assets/Device/DetailView/Tabs/CommonTab/DetailFrame/context";
import { usePolling } from "@common/hooks";
import { getGraph } from "@services/monitoring";
import {
  GraphType,
  MetaData,
  MonitoringGraphData,
} from "@services/monitoring/types";
import { Device } from "@services/devices/types";

type UseDeviceChartDataParams = {
  device: Device | undefined;
  graphType?: GraphType;
  customGraph?: MetaData;
  start: number;
  end: number;
};

export const useDeviceChartData = (params: UseDeviceChartDataParams) => {
  const { device, graphType, customGraph, start, end } = params;

  const { toggleState, calendarDate } = useContext(DeviceDetailContext);
  const [chartState, setChartState] = useState<MonitoringGraphData[]>([]);

  const refetch = useCallback(async () => {
    try {
      const type = customGraph ? customGraph.graphName : graphType;

      const isCustom = !!customGraph;

      const chartData = await getGraph(device?.id, start, end, type, isCustom);

      const safeChartData = chartData.map((dataset) => ({
        ...dataset,
        data: dataset.data ?? [],
      }));

      setChartState(safeChartData);
    } catch (e) {}
  }, [graphType, calendarDate, toggleState]);

  const poll = usePolling(refetch, 60e3);

  useEffect(() => {
    if (toggleState === "live") {
      if (!poll.isPolling) poll.start();
    }

    if (toggleState === "calendar") {
      if (poll.isPolling) poll.stop();
      refetch();
    }
  }, [toggleState, graphType, calendarDate]);

  useEffect(() => {
    return () => poll.stop();
  }, []);

  return chartState;
};
